module.exports = __webpack_public_path__ + "img/ko_kaeri2.33213daa.jpg";